
<template>

  <d-container fluid class="order-detail main-content-container align-items-center justify-content-center">
    <d-col cols="12 px-0">
      <d-row v-if="$apollo.queries.getSingleOrder.loading" class="justify-content-center">
        <d-col class="col-auto">
         
          <loader :loading="true" />
        </d-col>
      </d-row>

      <d-row v-else class="d-flex justify-content-center">
        <d-col class="col-12 col-xl-10">
          <router-link class="nav-link px-0 d-inline-block" :to="{ name: 'order.index' }">
            &lt; {{ $t('button.go_back') }}
          </router-link>

          <d-row class="justify-content-between">
            <d-col class="align-self-center" cols="auto">
              <d-row class="no-gutters">
                <d-col class="align-self-center" cols="auto">
                  <h2 class="my-3 mr-3 d-inline-block">
                    {{ $t(d_editMode ? 'order.edit.title' : 'order.detail.title') }} {{ d_order.reference }}
                  </h2>
                </d-col>

                <d-col class="align-self-center" cols="auto">
                  <div class="d-inline-block">
                    {{ d_order.status.toLowerCase()  }}
                    <popper :options="{ placement: 'top' }" trigger="hover">
                      <div class="popper-content">
                        {{ $t(`order.status.${d_order.status.toLowerCase()}`) }}
                      </div>

                      <i class="order-status-icon fa-2x line-height-h1" :class="c_orderStatusIcon" slot="reference" />
                    </popper>
                  </div>
                </d-col>
              </d-row>
            </d-col>

            <d-col v-if="c_canEdit && d_order.status.toLowerCase()!='cancelled'" class="align-self-center my-3 my-lg-0" cols="auto">
              <d-btn @click="toggleEditMode(true)" theme="secondary">
                {{ $t('order.action.edit') }}
              </d-btn>
            </d-col>
          </d-row>
        </d-col>

        <d-col class="col-12 col-xl-10">
          <order-form @hideForm="hideForm" :editMode="d_editMode" :order="d_order" />
        </d-col>

        <d-col v-if="!d_editMode" class="col-12 col-xl-10 mt-0 mt-lg-3">
          <d-row class="mt-3 justify-content-between">
            <d-col class="align-self-center" cols="auto">

              <template v-if="d_order.status === 'COMPLETED'">
                <r-button @click="downloadConfirmation" class="mb-lg-0 mr-3" :error="d_query.error" :loading="d_query.loading" :success="d_query.success" theme="primary"   >
                  {{ $t('order.action.download_confirmation') }}
                </r-button>

                <r-button @click="resendConfirmation" class="my-2" :error="d_mutation.error" :loading="d_mutation.loading" :success="d_mutation.success" theme="primary">
                  {{ $t('order.action.resend_confirmation') }}
                </r-button>
              </template>
            </d-col>
            
            <d-col v-if="(d_order.cancelable)" class="align-self-center" cols="auto">
              <d-button @click="showCancelModal" theme="danger">
                {{ $t('order.action.cancel_order') }}
              </d-button>
            </d-col>

            <d-col v-else class="align-self-center" cols="auto">
              <div v-if="d_order.status !='CANCELLED'" class="alert alert-danger">
              <div v-if="d_order.vendor_service_id ==null || d_order.vendor_service_id==0">
                {{ $t('order.cancel.banner_text') }}
              </div>
              <div v-else>
                {{ $t('order.cancel.banner_text_mobian') }}
              </div>
              </div>
            </d-col>

          </d-row>

          <d-row v-if="d_query.error">
            <d-col cols="auto">
              <div>
                {{ $t('error.query') }}
              </div>
            </d-col>
          </d-row>
        </d-col>
      </d-row>
    </d-col>
  </d-container>

</template>


<script>
import CancelModal from '@/components/order/CancelModal';
import OrderForm from '@/components/order/Form';
import Mutation from '@/library/Mutation';
import Query from '@/library/Query';
import Popper from 'vue-popperjs';
import moment from 'moment';


export default {
  name: 'order-detail',
  components: { CancelModal, OrderForm, Popper },
  created: function () {
    this.moment = moment;
    },
  data () {
    return {
      d_order: {},
      d_orderCopy: {},
      d_orderId: '',
      d_editMode: false,
      d_query: new Query(),
      d_mutation: new Mutation(),
    };

  },

  mounted () {

    this.d_orderId = this.$route.params.id;

    this.d_editMode = this.$route.query.hasOwnProperty('editMode');
  },
  computed: {
    c_orderStatusIcon () {
      switch (this.d_order.status) {
        case 'UNDETERMINED':
          return 'fas fa-question text-primary';
        case 'PENDING':
          return 'far fa-clock text-warning';
        case 'COMPLETED':
          return 'fas fa-check text-success';
        case 'CANCELLED':
          return 'fas fa-ban text-danger';
        default:
          break;
      }
    },
    c_canEdit () {
      return !this.d_editMode && this.d_order.editable;
    },

  },
  
  methods: {
    hideForm (value) {
      if (value) {
        this.d_orderCopy = this.copyWithoutReactivity(this.d_order);
      } else {
        this.d_order = this.copyWithoutReactivity(this.d_orderCopy);
      }

      this.toggleEditMode(false);
    },
    toggleEditMode (value = false) {
      this.d_editMode = value;

      if (!this.d_editMode) {
        this.d_query.reset();
      }
    },
    downloadConfirmation () {
      this.d_query.query(
        require('@/graphql/bookings/GetSingleOrderVoucher.gql'),
        {
          order: this.d_orderId,
        }
      ).then(({ data }) => {
            const booking = data.booking;
        if (booking.voucher === null || booking.voucher.url === null) {
          return;
        }

        this.downloadVoucher(booking.voucher.url);
      });
    },
    downloadVoucher (url) {
      const link = document.createElement('a');

      link.href = url;
      link.target = '_black';

      link.click();
    },
    resendConfirmation () {
      this.d_mutation.reset();

      this.d_mutation.mutate(
        require('@/graphql/bookings/SendConfirmation.gql'),
        {
          id: this.d_order.id,
        }
      );
    },
    showCancelModal () {
      const options = {
        props: {
          orderId: this.d_order.id,
        },
        modalComponent: CancelModal,
      };

      const modal = this.$helpers.modal(options);

      modal.on('cancelOrder', this.cancelOrder);

      modal.show();
    },
    cancelOrder ({ order }) {
      Object.assign(this.d_order, order);

      this.d_orderCopy = Object.assign({}, this.d_order);
    },
    checkOrderRestrictions () {
      if (this.$route.query.hasOwnProperty('fromEdit')) {
        this.$toasted.show(this.$t('toasted.order.edit.payment_received'));
      }

      if ((this.d_order.status === 'CANCELLED' || !this.d_order.editable) && this.d_editMode) {
        this.hideForm(false);
      }
    },
    copyWithoutReactivity (object) {
      return JSON.parse(JSON.stringify(object));
    },
  },
  apollo: {
    getSingleOrder: function () {
      return {
        variables: {
          order: this.$route.params.id,
        },
        update: function (data) {
          this.d_order = data.booking;
          this.d_orderCopy = this.copyWithoutReactivity(this.d_order);

          this.checkOrderRestrictions();
        },
        query: require('@/graphql/bookings/GetSingleBooking.gql'),
      };
    },
  },
};

</script>

